import axios from 'axios';

import {getAdResponse} from '@jobseeker/common-core/utils';
import type {AdsElementType, AdsOptions} from '@jobseeker/common-core/types';

const sortByOrder = (ads: AdsElementType[]) => {
  if (ads && ads.some(adElement => 'ordering' in adElement)) {
    return ads.sort(
      (a: any, b: any) => parseInt(a.ordering, 10) - parseInt(b.ordering, 10)
    );
  }
  return ads;
};

const loadAds = async (
  slotId: string,
  options?: AdsOptions,
  isCourseAds: boolean = false,
  returnEntireResponse = false
) => {
  let API_PATH = process.env.NEXT_PUBLIC_API_ADS;
  if (typeof window === 'undefined') {
    return [];
  }
  if (isCourseAds) {
    API_PATH = API_PATH + 'courses/';
  }

  const params: AdsOptions = {
    imageType: 'webp',
    ...(options?.courseId && {courseId: options.courseId}),
  };

  if (options?.categoryIds) {
    params['categoryIds'] =
      options.categoryIds === 'jobfeed' ? '' : options.categoryIds;
  }

  if (options?.page) {
    params['page'] = options.page;
  }

  if (options?.size) {
    params['size'] = options.size;
  }

  if (options?.exp) {
    params['exp'] = options.exp;
  }

  if (options?.gender) {
    params['gender'] = options.gender;
  }

  if (options?.functionalArea) {
    params['functionalArea'] = options.functionalArea;
  }

  if (options?.user_location) {
    params['user_location'] = options.user_location;
  }

  if (options?.tags) {
    params['tags'] = options.tags;
  }

  if (options?.shuffle) {
    params['shuffle'] = options.shuffle;
  }

  if (options?.orderby) {
    params['orderby'] = options.orderby;
  }

  if (options?.jobTags) {
    params['jobTags'] = options.jobTags;
  }

  if (options?.courseTags) {
    params['courseTags'] = options.courseTags;
  }

  try {
    const response = await axios.get(`${API_PATH}${slotId}`, {
      params: params,
    });
    if (returnEntireResponse) {
      return response?.data;
    }
    let allAds: /* eslint-disable @typescript-eslint/no-explicit-any */ any =
      [];
    const adList = response.data?.data?.adList;
    if (adList && adList.length > 0) {
      let adListFinal = adList;
      if (options?.categoryIds === 'jobfeed') {
        adListFinal = adList.filter(
          (j: any) => j?.metadata[0]['Allowed on JobFeeds'] === 1
        );
      }

      if (options?.onRotation) {
        if (adListFinal.length > 1) {
          const currentDate = new Date();
          const day = currentDate.getDate();
          const index = day % 2 === 0 ? 1 : 0;
          adListFinal = [adListFinal[index]];
        }
      }

      /* eslint-disable @typescript-eslint/no-explicit-any */
      adListFinal.forEach(({metadata, id, categoryIds}: any) => {
        if (metadata?.length > 0) {
          metadata[0]['id'] = id;
        }

        allAds = allAds.concat(getAdResponse(metadata, categoryIds));
      });

      return sortByOrder(allAds);
    }
  } catch (error) {
    console.log('🚀 ~ file: loadAds.ts:27 ~ loadAds ~ error:', error);
    return '';
  }
};

export default loadAds;
